import { useCallback } from 'react';
import { NavigateFunction, NavigateOptions, To, useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { localizePath, resolveSiteLocale } from '../utils/siteLocale';

export function useSiteLocale() {
    const { pathname } = useLocation();
    const language = useAppSelector(state => state.auth.authData?.language);
    return resolveSiteLocale(pathname, language);
}

export function useLocalizedNavigate(): NavigateFunction {
    const navigate = useNavigate();
    const locale = useSiteLocale();
    return useCallback<NavigateFunction>((to: To | number, options?: NavigateOptions) => {
        if (typeof to === 'number') {
            navigate(to);
        } else if (typeof to === 'string') {
            navigate(localizePath(to, locale), options);
        } else {
            navigate({ ...to, pathname: localizePath(to.pathname || '/', locale) }, options);
        }
    }, [navigate, locale]);
}
